import React, { useEffect, useState } from "react";
// import { useLocation  } from "react-router-dom";
import { useSelector } from "react-redux";
import Snackbar from "@material-ui/core/Snackbar";
import Layout from "../hoc/Layout";
import catchErrors from "../helpers/catchErrors";
import { readOne, participate } from "../helpers/events";
import { Button } from "semantic-ui-react";
import MuiAlert from "@material-ui/lab/Alert";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function EventPage({ location }) {
  const [error, setError] = useState("");
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isParicipating, setIsParicipating] = useState(false);

  const { user } = useSelector((state) => ({ ...state }));

  useEffect(() => {
    const changeButton = async () => {
      try {
        if (user && data.participants) {
          data.participants.map((p) => {
            // console.log(p.imageUrl, " P ", user.picture, " U ");
            if (p.imageUrl == user.picture) {
              setIsParicipating(true);
            }
          });
        }
      } catch (error) {
        catchErrors(error, setError);
      }
    };
    return changeButton();
  }, [user, data, location]);

  useEffect(() => {
    const response = async () => {
      try {
        // console.log(location.state._id);
        const response = await readOne(location.state._id);
        setData(response.data);

        // console.log(data);
      } catch (error) {
        catchErrors(error, setError);
      }
    };
    // console.log(data);
    return response();
  }, []);

  const handleParticipate = async () => {
    // console.log("user ", user._id);
    try {
      const authtoken = user.token;
      const respones = await participate(
        authtoken,
        data._id,
        user._id,
        user.picture
      );
      console.log(respones);
      setIsDisabled(true);
      setOpen(true);
    } catch (error) {
      catchErrors(error, setError);
    } finally {
      // setLoading(false);
    }
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
    // history.push("/user/events");
  };

  return (
    <Layout>
      <div className="createImage"></div>
      <div className="home ">
        <div className="content single-event">
          {data && (
            <>
              <div className="">
                <h2 className="subTitle">{data.title}</h2>
                <span>
                  On the {data.date && data.date.toString().split("T")[0]} At{" "}
                  {data.time}
                </span>
              </div>
              <p>{data.desc}</p>
            </>
          )}
          {isParicipating ? (
            <Button
              onClick={handleParticipate}
              type="button"
              basic
              color="purple"
              disabled={true}
            >
              You are in the game :)
            </Button>
          ) : (
            <Button
              onClick={handleParticipate}
              type="button"
              basic
              color="purple"
              disabled={isDisabled}
            >
              Participate
            </Button>
          )}

          <div className="avatars">
            {data.participants &&
              data.participants.map((p) => {
                return (
                  <div key={p._id}>
                    <img src={p.imageUrl} alt="avatar" />
                  </div>
                );
              })}
          </div>
          <Snackbar
            open={open}
            autoHideDuration={4000}
            onClose={handleClose}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <Alert onClose={handleClose} severity="success">
              <h3>Joined event successfully!</h3>
              {/* <h4>{}</h4> */}
            </Alert>
          </Snackbar>
        </div>
      </div>
    </Layout>
  );
}

export default EventPage;
